<template>
  <!-- star -->
  <div class="support_wrap">
    <navigation></navigation>
    <div class="banner_warp">
      <img class="banner_warp_img" src="../assets/img/service/support_banner.png"/>
    </div>

    <!-- support -->
    <div class="support">
      <div class="support-top"></div>
      <h1>服务支持</h1>
      <div class="support-line"></div>
      <div class="support-content">
        <el-form :model="supportForm" :rules="rules" label-position="top" ref="supportForm" label-width="80px"
                 class="support-form">
          <div class="support-label"><h2>基本信息</h2>
            <div class="support-label-line"></div>
          </div>
          <el-row>
            <el-form-item label="姓名" prop="contactName">
              <el-input v-model="supportForm.contactName" placeholder="请输入您的姓名" autocomplete="new-password"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="电话" prop="mobile">
              <el-input v-model="supportForm.mobile" placeholder="请输入您的电话号码" autocomplete="new-password"></el-input>
            </el-form-item>
          </el-row>
          <el-row class="support-el-row"> <!--:gutter="80"-->
            <el-col class="support-el-col" :span="12">  <!--:span="12"-->
              <el-form-item label="省份" class="support-el-item" prop="province">
                <el-select @change="handleChangeProvince" v-model="supportForm.province" filterable placeholder="请选择省份"
                           autocomplete="new-password" class="support-el-select">
                  <el-option v-for="item in provinceData" :key="item.value" :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col class="support-el-col" :span="12"> <!--:span="12"-->
              <el-form-item label="城市" class="support-el-item" prop="city">
                <el-select v-model="supportForm.city" filterable placeholder="请选择城市" autocomplete="new-password"
                           class="support-el-select">
                  <el-option v-for="item in cityData" :key="item.value" :label="item.label"
                             :value="item.label"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="support-space"></div>
          <div class="support-label"><h2>企业信息</h2>
            <div class="support-label-line"></div>
          </div>
          <el-row>
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="supportForm.companyName" placeholder="请输入公司名称" autocomplete="new-password"></el-input>
            </el-form-item>
          </el-row>
          <div class="support-space"></div>
          <div class="support-label"><h2>服务需求</h2>
            <div class="support-label-line"></div>
          </div>
          <el-row>
            <el-form-item label="服务需求" prop="remark">
              <el-input type="textarea" v-model="supportForm.remark" placeholder="请输入合作需求"
                        autocomplete="new-password"></el-input>
            </el-form-item>
          </el-row>
          <div class="support-space2"></div>
          <div class="support-label"><h2>产品类型</h2>
            <div class="support-label-line"></div>
          </div>
          <el-row>
            <el-form-item label="产品类型" prop="productType">
              <el-select v-model="supportForm.productType" placeholder="请选择产品类型" autocomplete="new-password"
                         class="support-el-select2">
                <el-option label="HY-S1系统" value="1"></el-option>
                <el-option label="HY-S2系统" value="2"></el-option>
                <el-option label="HY-S3系统" value="3"></el-option>
                <el-option label="HY-S4系统" value="4"></el-option>
                <el-option label="HY-S5系统" value="5"></el-option>
                <el-option label="按摩椅" value="6"></el-option>
                <el-option label="小件按摩产品" value="7"></el-option>
                <el-option label="其他" value="8"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row class="support-button-row">
            <el-form-item class="support-el-form-item">
              <el-button class="support-el-button" type="primary" @click="submitForm('supportForm')">提交</el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
    </div>
    <footer2></footer2>
    <!-- end -->
  </div>
</template>

<script>
import navigation from "../components/nav2.vue";
import footer2 from "../components/footer.vue";
import {addSupport} from "@/api";
import {regionData, codeToText} from 'element-china-area-data'

export default {
  name: "service",
  components: {
    navigation,
    footer2
  },
  data() {
    let validateMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入电话号码'));
      } else {
        let newValue = value.replace(/[^0-9]/gi, '')
        if (value !== newValue) {
          callback(new Error('请输入正确的电话号码'))
        } else if (newValue.length !== 11) {
          callback(new Error('请输入正确的电话号码'))
        } else {
          callback()
        }
      }
    };
    return {
      provinceData: regionData,
      cityData: [],
      supportForm: {
        contactName: '',
        mobile: '',
        province: '',
        city: '',
        companyName: '',
        remark: '',
        productType: '',
      },
      rules: {
        contactName: [
          {required: true, message: '请输入您的姓名', trigger: 'blur'},
        ],
        mobile: [
          {required: true, validator: validateMobile, trigger: 'blur'},
        ],
        province: [
          {required: true, message: '请选择省份', trigger: 'blur'},
        ],
        city: [
          {required: true, message: '请选择城市', trigger: 'blur'},
        ],
        companyName: [
          {required: true, message: '请输入企业名称', trigger: 'blur'},
        ],
        remark: [
          {required: true, message: '请输入合作需求', trigger: 'blur'},
        ],
        productType: [
          {required: true, message: '请选择产品类型', trigger: 'blur'},
        ]
      }
    };
  },
  mounted() {

  },
  methods: {
    handleChangeProvince(value) {
      this.cityData = []
      this.supportForm.city = ''
      const province = codeToText[value]
      this.supportForm.province = province;
      if (province === '北京市' || province === '天津市' || province === '上海市' || province === '重庆市' ||
          province === '香港特别行政区' || province === '澳门特别行政区') {
        const city = {value: value, label: province}
        this.cityData.push(city)
      } else {
        const childList = this.provinceData.find(i => i.value === value).children
        this.cityData.push(...childList)
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          addSupport(this.supportForm).then(response => {
            // console.log(12321);
            this.$message({
              message: '提交成功',
              type: 'success'
            });
          });
        } else {
          // console.log('error submit!!');
          this.$message.error('请输入必填项！');
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
/*=========================Reset_start==========================*/
/*去内外边距*/
html,
body {
  font-family: "微软雅黑", "宋体", Arail, Tabhoma;
  text-align: left;
}

/*字体 文本居左*/
ul {
  list-style: none;
}

/*去ul li 小点*/
img {
  border: 0 none;
}

/*img IE6 兼容问题*/
input,
select,
textarea {
  outline: 0;
}

/*去除点击蓝框*/
textarea {
  resize: none;
  overflow: auto;
}

/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
  font-weight: normal;
  font-style: normal;
}

/*特殊文字粗细 样式显示正常*/
a {
  text-decoration: none;
}

/*a标签去下划线*/
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}

/*清浮动*/
a {
  color: #000000;
}

/*==========================Reset_End===========================*/
.support_wrap {
  width: 100vw;
  margin: 0 auto;
}

.banner_warp {
  width: 1920px;
  height: 366px;
}

.banner_warp_img {
  width: 1920px;
  z-index: -999;
  position: absolute;
  height: 366px;
}

.support {
  width: 100%;
  height: 1760px;
  background-size: contain;
}

.support h1 {
  color: #000000;
  font-size: 24px;
  line-height: 90px;
  text-align: center;
  font-weight: 600;
  font-family: PingFang SC, PingFang SC;
}

.support-top {
  width: 100%;
  padding-top: 60px;
}

.support-line {
  margin: auto;
  width: 252px;
  height: 0px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #B1B1B1;
}

.support-content {
  width: 740px;
  height: 900px;
  margin: 0 auto;
  margin-top: 50px;
}

.support-form {
  width: 740px;
  height: 900px;
}

.el-row {
  padding-top: 20px;
}

.el-form-item {
  width: 740px;
  height: 90px;
}

.support-el-row {
  margin-right: -40px;
  margin-left: -40px;
}

.support-el-col {
  /*float: left;*/
  padding-right: 40px;
  padding-left: 40px;
}

/deep/ .el-col-24 {
  /*width: 410px;*/
}

.support-el-item {
  width: 330px;
  height: 90px;
}

.support-el-select {
  width: 330px;
  /*height: 90px;*/
}

.support-el-select2 {
  width: 740px;
  /*height: 90px;*/
}

/deep/ .el-form-item__label {
  line-height: 40px;
  font-size: 14px;
  color: #000000;
  font-weight: 600;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  margin-right: 4px;
  color: #E92424;
}

/deep/ .el-form-item__content {
  line-height: 40px;
  font-size: 14px;
}

/deep/ .el-input {
  font-size: 14px;
}

/deep/ .el-input__inner {
  line-height: 40px;
  border-radius: 4px;
  height: 40px;
  padding: 0 15px;
  border: 1px solid #DCDFE6;
}

.support-label h2 {
  color: #4B72B8;
  font-weight: 600;
  line-height: 19px;
  font-family: PingFang SC, PingFang SC;
  font-size: 16px;
}

.support-label-line {
  margin-top: 12px;
  width: 110px;
  height: 0px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #4B72B8;
}

.support-space {
  margin-top: 50px;
}

.support-space2 {
  margin-top: 300px;
}

.el-textarea {
  width: 740px;
  height: 300px;
}

/deep/ .el-textarea__inner {
  padding: 5px 15px;
  width: 740px;
  height: 300px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  font-size: 14px;
}

.support-button-row {
  width: 740px;
  height: 132px;
}

.support-el-form-item {
  margin-top: 50px;
  margin-left: 260px;
}

.support-el-button {
  background-color: #4B72B8;
  width: 237px;
  height: 42px;
  border-radius: 0px 0px 0px 0px;
  font-size: 14px;
  padding: 12px 20px;
  border: 1px solid #4B72B8;
}

/deep/ .el-form-item__error {
  font-size: 12px;
  padding-top: 4px;
}

.el-select-dropdown__item {
  font-size: 14px;
  line-height: 34px;
}

/deep/ .el-input__suffix {
  right: 5px;
}

/deep/ .el-input__icon {
  width: 25px;
  line-height: 40px;
}

.el-button--primary:focus, .el-button--primary:hover {
  background-color: #4B72B8;
  border-color: #4B72B8;
}

</style>
